const CalendarMonthSelect = ({
  dateValues,
  changeCalendarDate,
  allYear = false,
}) => {
  return (
    <select
      className="form-select month-select"
      aria-label="Default select example"
      value={dateValues.month}
      onChange={(e) => changeCalendarDate(dateValues.year, e.target.value)}
    >
      {allYear && <option value="">Todos los meses</option>}
      <option value="1">Enero</option>
      <option value="2">Febrero</option>
      <option value="3">Marzo</option>
      <option value="4">Abril</option>
      <option value="5">Mayo</option>
      <option value="6">Junio</option>
      <option value="7">Julio</option>
      <option value="8">Agosto</option>
      <option value="9">Septiembre</option>
      <option value="10">Octubre</option>
      <option value="11">Noviembre</option>
      <option value="12">Diciembre</option>
    </select>
  );
};

export default CalendarMonthSelect;
